/**
 * Shared PrimeVue tooltip helper for long left-nav titles.
 *
 * Why not rely on PrimeVue defaults?
 * - fitContent:true + unbroken strings produces a tall narrow strip.
 * - Sidebar nav uses v-tooltip.right so the portal opens over main content;
 *   CSS (.nav-title-tooltip) only sets width/z-index after that.
 *
 * escape defaults to true so plain title text is never treated as HTML.
 */

const NAV_TITLE_TOOLTIP_CLASS = 'nav-title-tooltip';

export function navTitleTooltip(value) {
    if (!value) {
        return null;
    }

    return {
        value,
        escape: true,
        fitContent: false,
        class: NAV_TITLE_TOOLTIP_CLASS,
    };
}

/**
 * The tooltip directive listens on the clamped label span itself, but focus
 * can land on an ancestor (e.g. the Tree's roving-tabindex row) when the span
 * isn't independently focusable. Resolve down to the label so the synthetic
 * mouse event reaches the element the directive is actually bound to.
 */
function resolveNavTitleTooltipTarget(root) {
    if (!root) {
        return null;
    }

    if (root.matches?.('.nav-title-clamp-2')) {
        return root;
    }

    return root.querySelector?.('.nav-title-clamp-2') ?? root;
}

export function showNavTitleTooltipOnFocus(event) {
    resolveNavTitleTooltipTarget(event.currentTarget)?.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
}

export function hideNavTitleTooltipOnBlur(event) {
    resolveNavTitleTooltipTarget(event.currentTarget)?.dispatchEvent(new MouseEvent('mouseleave', { bubbles: true }));
}
